var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckboxWrong({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 3,
    width: 18,
    height: 18,
    fill: "#DE2350"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.8462 9.89627C15.0513 9.69123 15.0513 9.35881 14.8462 9.15378C14.6412 8.94874 14.3088 8.94874 14.1037 9.15378L12 11.2575L9.89627 9.15378C9.69124 8.94874 9.35882 8.94874 9.15378 9.15378C8.94875 9.35881 8.94875 9.69123 9.15378 9.89627L11.2575 12L9.15378 14.1037C8.94874 14.3088 8.94874 14.6412 9.15378 14.8462C9.35881 15.0513 9.69123 15.0513 9.89627 14.8462L12 12.7425L14.1037 14.8462C14.3088 15.0513 14.6412 15.0513 14.8462 14.8462C15.0513 14.6412 15.0513 14.3088 14.8462 14.1037L12.7425 12L14.8462 9.89627Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckboxWrong);
export default __webpack_public_path__ + "static/media/Checkbox_wrong.a50212bd61b34e8dfb2d42e3645b621e.svg";
export { ForwardRef as ReactComponent };